import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin, FaPhone, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { FaBars } from 'react-icons/fa6';
import emailjs from '@emailjs/browser';
import * as S from './styles';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import WebDesign from './pages/ServiceDetail/WebDesign';
import SocialMedia from './pages/ServiceDetail/SocialMedia';
import SEO from './pages/ServiceDetail/SEO';
import CorporateMail from './pages/ServiceDetail/CorporateMail';
import MobileApp from './pages/ServiceDetail/MobileApp';
import Photography from './pages/ServiceDetail/Photography';
import EmailMarketing from './pages/ServiceDetail/EmailMarketing';
import WordPressServices from './pages/ServiceDetail/WordPressServices';
import AdvertisingManagement from './pages/ServiceDetail/AdvertisingManagement';
import ContactPage from './pages/ContactPage';
import ServerServices from './pages/ServiceDetail/ServerServices';
import TrademarkServices from './pages/ServiceDetail/TrademarkServices';
import GoogleBusiness from './pages/ServiceDetail/GoogleBusiness';
import ReferencesPage from './pages/ReferencesPage';
import styled from 'styled-components';
import HomePage from './pages/HomePage';

const WhatsAppButton = styled(motion.a)`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background: #25D366;
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
  z-index: 1000;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(37, 211, 102, 0.4);
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    font-size: 1.8rem;
    bottom: 1.5rem;
    right: 1.5rem;
  }
`;

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [prevTestimonial, setPrevTestimonial] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const testimonials = [
    {
      text: "Pozitif, güleryüzlü ve enerji dinamiği yüksek Demirer Dijital ekibi ile çalışmak çok keyifliydi. Web sitemizin tasarımı ve Google İşletme Kaydı sürecinde gösterdikleri profesyonel yaklaşım için Selim Bey ve ekibine teşekkür ederim.",
      author: "Esmanur BALCI",
      role: "Web Tasarım ve Google İşletme Kaydı"
    },
    {
      text: "Birçok web sitem kendisine emanet hızlı çözüm ve kaliteli hizmet. Şirket kurucusu Selim Demirer'e ilgi ve alakası için teşekkür ederim...",
      author: "Yıldıray ŞAHİN",
      role: "Sunucu Hizmetleri"
    },
    {
      text: "Web sitemizin tasarımı ve Google İşletme Kaydı sürecinde gösterdikleri profesyonel yaklaşım için Selim Bey ve ekibine teşekkür ederim. Özellikle Google'da görünürlüğümüzün artması işlerimize çok olumlu yansıdı.",
      author: "Elif ARSLAN",
      role: "Web Tasarım ve Google İşletme Kaydı"
    },
    {
      text: "Futbol maçlarımdaki fotoğraf çekimleri için tercih ettiğimiz Demirer Dijital ekibi, profesyonel yaklaşımları ve kaliteli işleriyle beklentilerimizin ötesinde bir hizmet sundu.",
      author: "Davit HOVSEPYAN",
      role: "Fotoğraf Çekimi"
    },
    {
      text: "Sosyal medya hesaplarımızın yönetimini Demirer Dijital'e emanet ettik. Profesyonel içerik üretimi ve stratejik yönetim sayesinde takipçi sayımız ve etkileşimlerimiz katlanarak arttı. Selim Bey ve ekibine teşekkürlerimizi sunarız.",
      author: "Cevat YILMAZ",
      role: "Sosyal Medya Yönetimi"
    }
  ];


  useEffect(() => {
    const interval = setInterval(() => {
      setPrevTestimonial(currentTestimonial);
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [currentTestimonial]);

  const handleDotClick = (index) => {
    setPrevTestimonial(currentTestimonial);
    setCurrentTestimonial(index);
  };

  const handleMouseMove = (e) => {
    const { clientX, clientY } = e;
    const { innerWidth, innerHeight } = window;
    
    // Calculate mouse position as percentage
    const x = (clientX / innerWidth) * 100;
    const y = (clientY / innerHeight) * 100;
    
    // Calculate rotation angles (max 10 degrees)
    const xRotate = ((x - 50) / 50) * 10;
    const yRotate = ((y - 50) / 50) * -10;
    
    // Update CSS variables
    document.documentElement.style.setProperty('--mouse-x', `${x}%`);
    document.documentElement.style.setProperty('--mouse-y', `${y}%`);
    document.documentElement.style.setProperty('--mouse-x-rotate', `${xRotate}deg`);
    document.documentElement.style.setProperty('--mouse-y-rotate', `${yRotate}deg`);
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    phone: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phone') {
      // Only allow numbers and limit to exactly 11 digits
      const numbersOnly = value.replace(/[^\d]/g, '');
      if (numbersOnly.length <= 11) {
        setFormData({
          ...formData,
          [name]: numbersOnly
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check if phone number is exactly 11 digits
    if (formData.phone.length !== 11) {
      alert('Telefon numarası 11 haneli olmalıdır.');
      return;
    }

    setIsSubmitting(true);

    try {
      await emailjs.sendForm(
        'service_771tgg7',
        'template_w676du8',
        formRef.current,
        'xjG6_a9zdp6ZU1zHp'
      );

      alert('Başarılı');
      setFormData({ name: '', phone: '' });
    } catch (error) {
      console.error('Error sending email:', error);
      alert('Bir hata oluştu.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <Router>
      <ScrollToTop />
      <S.AppContainer onMouseMove={handleMouseMove}>
        <S.DynamicBackground />
        
        <S.Header
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <S.HeaderContent>
            <S.Logo
              as={Link} to="/"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              <img src="/media/demirer-ajans-logo.png" alt="Demirer Ajans Logo" style={{ height: '50px', marginRight: "10px", verticalAlign: 'middle' }} />
              Demirer Ajans
            </S.Logo>
            <S.HamburgerMenu onClick={toggleMenu}>
              <FaBars />
            </S.HamburgerMenu>
            <S.Nav 
              isOpen={isMenuOpen}
              initial={false}
              animate={isMenuOpen ? { 
                display: "flex",
                opacity: 1,
                height: "auto",
                transition: {
                  duration: 0.3,
                  ease: "easeInOut"
                }
              } : { 
                display: "none",
                opacity: 0,
                height: 0,
                transition: {
                  duration: 0.3,
                  ease: "easeInOut"
                }
              }}
            >
              <S.NavLink to="/" onClick={() => setIsMenuOpen(false)}>Ana Sayfa</S.NavLink>
              <S.NavLink to="/about" onClick={() => setIsMenuOpen(false)}>Hakkımızda</S.NavLink>
              <S.NavLink to="/services" onClick={() => setIsMenuOpen(false)}>Hizmetlerimiz</S.NavLink>
              <S.NavLink to="/references" onClick={() => setIsMenuOpen(false)}>Referanslarımız</S.NavLink>
              <S.NavLink to="/contact" onClick={() => setIsMenuOpen(false)}>İletişim</S.NavLink>
            </S.Nav>
          </S.HeaderContent>
        </S.Header>

        <Routes>
          <Route path="/" element={
            <HomePage
              testimonials={testimonials}
              currentTestimonial={currentTestimonial}
              prevTestimonial={prevTestimonial}
              handleDotClick={handleDotClick}
              formRef={formRef}
              formData={formData}
              handleInputChange={handleInputChange}
              handleSubmit={handleSubmit}
              isSubmitting={isSubmitting}
            />
          } />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/references" element={<ReferencesPage />} />
          <Route path="/services/kurumsal-web-tasarim" element={<WebDesign />} />
          <Route path="/services/sosyal-medya-yonetimi" element={<SocialMedia />} />
          <Route path="/services/performans-odakli-seo" element={<SEO />} />
          <Route path="/services/kurumsal-mail-hizmeti" element={<CorporateMail />} />
          <Route path="/services/mobil-uygulama" element={<MobileApp />} />
          <Route path="/services/fotograf-cekimi" element={<Photography />} />
          <Route path="/services/e-posta-pazarlama" element={<EmailMarketing />} />
          <Route path="/services/wordpress-hizmetleri" element={<WordPressServices />} />
          <Route path="/services/reklam-yonetimi" element={<AdvertisingManagement />} />
          <Route path="/services/sunucu-hizmetleri" element={<ServerServices />} />
          <Route path="/services/marka-tescil-hizmeti" element={<TrademarkServices />} />
          <Route path="/services/google-isletme-kaydi" element={<GoogleBusiness />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>

        <WhatsAppButton
          href="https://wa.me/905325743379"
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <FaWhatsapp />
        </WhatsAppButton>

        <S.Footer>
          <S.FooterGrid>
            <S.CompanyInfo>
              <S.FooterLogoText>
                <img src="/media/demirer-ajans-logo.png" alt="Demirer Ajans Logo" style={{ height: '40px', marginRight: "10px", verticalAlign: 'middle' }} />
                Demirer Ajans
              </S.FooterLogoText>
              <S.FooterContact>
                <p>Eyüpsultan / İstanbul</p>
                <a href="mailto:demirerajans@gmail.com">
                  <FaEnvelope /> demirerajans@gmail.com
                </a>
                <a href="tel:+908509334655">
                  <FaPhone /> 0850 933 4655
                </a>
                <a href="https://wa.me/905325743379" target="_blank" rel="noopener noreferrer">
                  <FaWhatsapp /> 0532 574 3379
                </a>
              </S.FooterContact>
              <S.SocialLinks>
                <a href="https://www.linkedin.com/company/demirerajans/" target="_blank" rel="noopener noreferrer" className="linkedin"><FaLinkedin /></a>
                <a href="https://www.instagram.com/demirerajans/" target="_blank" rel="noopener noreferrer" className="instagram"><FaInstagram /></a>
                <a href="https://www.facebook.com/profile.php?id=61577181878607" target="_blank" rel="noopener noreferrer" className="facebook"><FaFacebook /></a>
                <a href="https://x.com/demirerajans" target="_blank" rel="noopener noreferrer" className="x"><FaXTwitter /></a>
              </S.SocialLinks>
            </S.CompanyInfo>
            <div>
              <S.FooterSectionTitle>Hizmetlerimiz</S.FooterSectionTitle>
              <S.FooterNav>
                <S.FooterNavLink to="/services/kurumsal-web-tasarim">Kurumsal Web Tasarım</S.FooterNavLink>
                <S.FooterNavLink to="/services/mobil-uygulama">Mobil Uygulama</S.FooterNavLink>
                <S.FooterNavLink to="/services/fotograf-cekimi">Fotoğraf Çekimi</S.FooterNavLink>
                <S.FooterNavLink to="/services/sunucu-hizmetleri">Sunucu Hizmetleri</S.FooterNavLink>
                <S.FooterNavLink to="/services/marka-tescil-hizmeti">Marka Tescil Hizmeti</S.FooterNavLink>
                <S.FooterNavLink to="/services/google-isletme-kaydi">Google İşletme Kaydı</S.FooterNavLink>
              </S.FooterNav>
            </div>

            <div>
              <S.FooterSectionTitle>Dijital Pazarlama</S.FooterSectionTitle>
              <S.FooterNav>
                <S.FooterNavLink to="/services/sosyal-medya-yonetimi">Sosyal Medya Yönetimi</S.FooterNavLink>
                <S.FooterNavLink to="/services/performans-odakli-seo">Performans Odaklı SEO</S.FooterNavLink>
                <S.FooterNavLink to="/services/wordpress-hizmetleri">WordPress Hizmetleri</S.FooterNavLink>
                <S.FooterNavLink to="/services/kurumsal-mail-hizmeti">Kurumsal Mail Hizmeti</S.FooterNavLink>
                <S.FooterNavLink to="/services/e-posta-pazarlama">E-Posta Pazarlama</S.FooterNavLink>
                <S.FooterNavLink to="/services/reklam-yonetimi">Reklam Yönetimi</S.FooterNavLink>
              </S.FooterNav>
            </div>
          </S.FooterGrid>
          <S.FooterCopyright>
            &copy; {new Date().getFullYear()} Demirer Ajans. Tüm Hakları Saklıdır.
          </S.FooterCopyright>
        </S.Footer>
      </S.AppContainer>
    </Router>
  );
}

export default App;